import React, { useEffect } from "react";
import "react-day-picker/lib/style.css";
import "./App.css";
import "./DarkMode.scss";
import { connect } from "react-redux";

import { setUser, setNullUser } from "./store/actions/authActions";
import "./config/firebase";
import { auth } from "./config/firebase";
import "./config/API";
import Routes from "./components/layouts/Routes";
import { QueryClient, QueryClientProvider } from "react-query";
import { GlobalProvider } from "./context";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App = ({ setUser, authLoaded, setNullUser }) => {
  useEffect(() => {
    auth.onAuthStateChanged((newUser) => {
      if (!newUser) {
        setNullUser();
      }

      if (newUser) {
        setUser(newUser);
      }
    });
  }, [setNullUser, setUser]);

  if (!authLoaded) return null;

  return (
    <QueryClientProvider client={queryClient}>
      <GlobalProvider>
        <div className="App">
          <Routes />
        </div>
      </GlobalProvider>
    </QueryClientProvider>
  );
};

const mapStateToProps = (state) => ({
  authLoaded: state.firebase.auth.isLoaded,
});

export default connect(mapStateToProps, { setUser, setNullUser })(App);
